interface StatCardProps {
  icon: React.ReactNode
  label: string
  value: string | number
  color?: 'success' | 'warning' | 'danger' | 'info' | 'primary'
  trend?: string
  onClick?: () => void
}

export default function StatCard({ icon, label, value, color = 'primary', trend, onClick }: StatCardProps) {
  return (
    <div
      className={`stat-card-v2${onClick ? ' stat-card-v2--clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick() } : undefined}
    >
      <div className={`stat-card-v2__icon stat-card-v2__icon--${color}`}>
        {icon}
      </div>
      <div className="stat-card-v2__body">
        <span className="stat-card-v2__label">{label}</span>
        <span className={`stat-card-v2__value stat-card-v2__value--${color}`}>{value}</span>
        {trend && (
          <span className="stat-card-v2__trend">{trend}</span>
        )}
      </div>
    </div>
  )
}
